import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from "react";
import boundingClientRect from "../../utils/boundingClientRect";
import getScrollableParent from "../helpers/getScrollableParent";

var useDimensions = function useDimensions(_ref) {
  var containerRef = _ref.containerRef,
      popover = _ref.popover,
      content = _ref.content,
      fixed = _ref.fixed;

  var _useState = useState({
    containerTop: 0,
    containerPureTop: 0,
    containerLeft: 0,
    containerHeight: 0,
    containerWidth: 0,
    popoverHeight: 0,
    popoverWidth: 0,
    windowScrollTop: 0,
    windowWidth: 0,
    windowHeight: 0,
    contentHeight: 0,
    documentHeight: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      positions = _useState2[0],
      setPositions = _useState2[1];

  useEffect(function () {
    var calculate = function calculate() {
      var containerDimensions = boundingClientRect(containerRef);
      var popoverDimensions = boundingClientRect(popover);
      var contentDimensions = boundingClientRect(content);

      if (containerDimensions && popoverDimensions && contentDimensions && typeof window !== "undefined") {
        var documentDimensions = window.document.body.getBoundingClientRect();
        setPositions({
          containerTop: containerDimensions.top,
          containerLeft: containerDimensions.left,
          containerHeight: containerDimensions.height,
          containerWidth: containerDimensions.width,
          containerPureTop: containerDimensions.pureTop,
          popoverHeight: popoverDimensions.height,
          popoverWidth: popoverDimensions.width,
          windowScrollTop: window.scrollY || window.pageYOffset,
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight,
          contentHeight: contentDimensions.height,
          documentHeight: documentDimensions.height
        });
      }
    };

    var scrollableparent = getScrollableParent(containerRef.current);
    calculate();
    window.addEventListener("resize", calculate);
    if (fixed) window.addEventListener("scroll", calculate);
    if (scrollableparent !== document.body && scrollableparent) scrollableparent.addEventListener("scroll", calculate);
    return function () {
      window.removeEventListener("resize", calculate);
      if (fixed) window.removeEventListener("scroll", calculate);
      if (scrollableparent !== document.body && scrollableparent) scrollableparent.removeEventListener("scroll", calculate);
    };
  }, [containerRef, content, popover, fixed]);
  return positions;
};

export default useDimensions;